import React, { Component } from 'react'
import PropTypes from 'prop-types'

import ClubFeedNotificationCheckbox from '../../../../shared/components/club_feed_notification_checkbox'

const withSkipNotifications = (href, skip) => {
  if (!href || !skip) {
    return href
  }

  return `${ href }${ href.includes('?') ? '&' : '?' }skip_notifications=1`
}

class MobileScoreWarningPopup extends Component {
  constructor(props){
    super(props)
    this.state = {
      skipNotifications: false,
    }
  }

  render() {
    const { toggleTournamentStatusLink, disableMobileScoringLink, clubFeedChannels, clubFeedSettingsUrl, clubFeedLearnMoreUrl } = this.props
    const { skipNotifications } = this.state

    return (
      <div className="modal club_feed_confirm_popup" id="disable_mobile_scoring_modal" tabIndex="-1" role="dialog" aria-hidden="true" aria-labelledby="disable_mobile_scoring_modal_message">
        <div className="modal-dialog" role="document">
            <div className="modal-content">
                <div className="modal-body">
                  <div id="modal_content">
                    <p id="disable_mobile_scoring_modal_message">{window.I18n.t('rounds.bootstrap_partials.portal_and_mobile.mobile_score_warning', window.participantFormats)}</p>
                    <ClubFeedNotificationCheckbox
                      channels={ clubFeedChannels }
                      settingsUrl={ clubFeedSettingsUrl }
                      learnMoreUrl={ clubFeedLearnMoreUrl }
                      checked={ skipNotifications }
                      onChange={ (checked) => this.setState({ skipNotifications: checked }) }
                      inputId="club_feed_skip_notifications_mobile_scoring"
                    />
                  </div>
                  <fieldset className="submit_bar clearfix">
                    <a href={ withSkipNotifications(disableMobileScoringLink, skipNotifications) } className='btsp_orange_button save_button pull-right btn save-enable-tee' >{window.I18n.t('rounds.bootstrap_partials.portal_and_mobile.yes_button')}</a>
                    <a href={ withSkipNotifications(toggleTournamentStatusLink, skipNotifications) } className='btn button btsp_gray_button pull-right cancel-enable-tee' >{window.I18n.t('rounds.bootstrap_partials.portal_and_mobile.no_button')}</a>
                  </fieldset>
                </div>
            </div>
        </div>
      </div>
    )
  }
}


MobileScoreWarningPopup.propTypes = {
  toggleTournamentStatusLink: PropTypes.string,
  disableMobileScoringLink: PropTypes.string,
  clubFeedChannels: PropTypes.shape({
    feed: PropTypes.bool,
    push: PropTypes.bool,
    push_notification: PropTypes.bool,
  }),
  clubFeedSettingsUrl: PropTypes.string,
  clubFeedLearnMoreUrl: PropTypes.string,
}


export default MobileScoreWarningPopup
